




















































import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { Popup, Field, Loading, NoticeBar, Picker } from "vant";
import dataShare from "@/views/mall/dataShare";
import trainService from "@/service/trainService";
import roleUtils from "@/utils/roleUtils";
import { CardType } from "@/model/Base";
@Component({
  name: "trainFindPassword",
  components: {
    [Field.name]: Field,
    [Popup.name]: Popup,
    [Picker.name]: Picker,
    [Loading.name]: Loading,
    [Field.name]: Field,
    [NoticeBar.name]: NoticeBar,
  },
})
export default class trainAccount extends Vue {
  // //data
  // dataShare = dataShare;
  showCardType = false;
  isShowPopup = false;
  isLoading = false;
  model = {
    requestId: "",
    PhoneNo: "",
    PassWord: "",
    PassWordcfm: "",
    CardType: CardType.IDCard,
    CardNo: "",
    randcode: "",
  };

  get cardName() {
    return this.columns.filter((o: any) => o.value == this.model.CardType)[0].text;
  }
  columns = roleUtils.BuildCardTypes().filter((o: any) => o.value != CardType.OtherCard);
  //methods
  back() {
    history.back();
  }
  save() {
    this.isLoading = true;
    let __self = this;
    trainService.retrieveSendCaptcha(this.model).then(json => {
      __self.isLoading = false;
      // json.isSucc = true;
      if (!json.isSucc) {
        __self.$dialog
          .alert({
            message: json.message,
            closeOnPopstate: true,
          })
          .then(() => {
            if (json.isSucc) {
              history.back();
            }
          })
          .catch(() => {});
        return;
      }
      this.model.requestId = json.result.requestId;
      __self.isShowPopup = true;
    });
  }
  fill() {
    let __self = this;

    if (this.model.PassWord != this.model.PassWordcfm) {
      __self.$dialog
        .alert({
          message: "确认密码与新密码不符",
          closeOnPopstate: true,
        })
        .then(() => {})
        .catch(() => {});
      return;
    }
    trainService.retrieveFillCaptcha(this.model).then(json => {
      __self.isShowPopup = false;
      __self.$dialog
        .alert({
          message: json.isSucc ? "密码找回成功，请使用新密码登录" : json.message,
          closeOnPopstate: true,
        })
        .then(() => {
          if (json.isSucc) {
            history.back();
          }
        })
        .catch(() => {});
    });
  }

  onCardSelected(selected: any) {
    this.showCardType = false;
    this.model.CardType = selected.value;
    console.log(this.model.CardType);
  }
}
